import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/template/category/[id]/CategoryContent.tsx");
